import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {DiagnosisDTO} from '../models/DiagnosisDTO';

@Injectable({providedIn: 'root'})
export class DiagnosisService {
  private readonly url = environment.baseUrl + '/diagnosis';

  constructor(private httpClient: HttpClient) {}

  getListOfDiagnoses(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<DiagnosisDTO>> {
    return this.httpClient.post<PagedResponseDTO<DiagnosisDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  searchDiagnoses(search: string): Observable<PagedResponseDTO<DiagnosisDTO>> {
    const request = new PagedRequestDTO();
    request.entityClass = 'TblDiagnosis';
    request.pageNumber = 0;
    request.pageSize = 20;
    request.sortField = 'code';
    request.sortDirection = 'ASCENDING';
    request.fieldMap = {
      code: {name: 'code', value: search, logicGate: 'AND', bracket: '('},
      description: {name: 'description', value: search, logicGate: 'OR', bracket: ')'}
    };
    return this.getListOfDiagnoses(request);
  }
}
